/**
 * The permission keys this client checks, mirroring the constants the Go
 * packages declare. Spelling them out once here keeps the strings out of the
 * components; the server refuses anything these get wrong, and the admin app
 * lists the real catalogue straight from the API.
 */
export const PERMISSIONS = {
  directory: {
    view: "users.directory.view",
    create: "users.directory.create",
    update: "users.directory.update",
    delete: "users.directory.delete",
  },
  adminUsers: {
    view: "admin.users.view",
    create: "admin.users.create",
    update: "admin.users.update",
  },
  adminRoles: {
    view: "admin.roles.view",
    create: "admin.roles.create",
    update: "admin.roles.update",
    delete: "admin.roles.delete",
  },
  calendar: {
    overview: "calendar.overview.view",
    eventsView: "calendar.events.view",
    eventsCreate: "calendar.events.create",
    eventsUpdate: "calendar.events.update",
    eventsDelete: "calendar.events.delete",
    campaignsView: "calendar.campaigns.view",
    campaignsCreate: "calendar.campaigns.create",
    campaignsUpdate: "calendar.campaigns.update",
    campaignsDelete: "calendar.campaigns.delete",
    lineItemsCreate: "calendar.lineitems.create",
    lineItemsUpdate: "calendar.lineitems.update",
    lineItemsDelete: "calendar.lineitems.delete",
  },
  sales: {
    dashboard: "sales.dashboard.view",
    repsView: "sales.reps.view",
    repsUpdate: "sales.reps.update",
    syncRun: "sales.sync.run",
  },
  slack: {
    channelsManage: "slack.channels.manage",
  },
  games: {
    play: "games.puzzles.play",
    leaderboardView: "games.leaderboard.view",
    resultsReset: "games.results.reset",
  },
  receptionist: {
    messagesView: "receptionist.messages.view",
    messagesUpdate: "receptionist.messages.update",
    knowledgeView: "receptionist.knowledge.view",
    knowledgeUpdate: "receptionist.knowledge.update",
  },
} as const;

/**
 * The optional integrations this client has controls for, mirroring the
 * constants the Go packages declare. A feature the server reports is one it has
 * the configuration to deliver, which is a separate question from whether the
 * person in front of it is allowed to use it.
 */
export const FEATURES = {
  slack: {
    eventChannels: "slack.eventChannels",
  },
} as const;
